"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--backgroundColor, transparent)",
  d: "M21.3 13.511H9.358V10.53H21.3v2.982Zm0 6.084H9.358v-2.982H21.3v2.982Zm0-12.207H9.358V4.405H21.3v2.983Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.658 4.405a.7.7 0 0 1 .7-.7H21.3a.7.7 0 0 1 .7.7v2.983a.7.7 0 0 1-.7.7H9.358a.7.7 0 0 1-.7-.7V4.405Zm1.4.7v1.583H20.6V5.105H10.058Zm-3.19-.93a.7.7 0 0 1 .002.99L4.592 7.453a.7.7 0 0 1-.992 0L2.204 6.05a.7.7 0 0 1 .992-.989l.9.904 1.782-1.789a.7.7 0 0 1 .99-.001Zm1.79 6.353a.7.7 0 0 1 .7-.7H21.3a.7.7 0 0 1 .7.7v2.983a.7.7 0 0 1-.7.7H9.358a.7.7 0 0 1-.7-.7V10.53Zm1.4.7v1.583H20.6V11.23H10.058Zm-3.19-.929a.7.7 0 0 1 .002.99l-2.278 2.286a.7.7 0 0 1-.992 0l-1.396-1.4a.7.7 0 0 1 .992-.989l.9.904 1.782-1.79a.7.7 0 0 1 .99-.002Zm1.79 6.314a.7.7 0 0 1 .7-.7H21.3a.7.7 0 0 1 .7.7v2.982a.7.7 0 0 1-.7.7H9.358a.7.7 0 0 1-.7-.7v-2.982Zm1.4.7v1.582H20.6v-1.582H10.058Zm-3.19-.93a.7.7 0 0 1 .002.99L4.592 19.66a.7.7 0 0 1-.992 0l-1.396-1.4a.7.7 0 0 1 .992-.989l.9.904 1.782-1.789a.7.7 0 0 1 .99-.002Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=TaskListIcon24.js.map